import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { VIEW_SIZE } from 'utils/device';
import styles from './SharedProduct.module.css';

const SharedProduct = ({ product, viewSize }) => {
  const { productName, brandName, imageUrl, percentOff } = product;
  if (!productName || !imageUrl) return null;
  const mobileDevices =
    viewSize === VIEW_SIZE.small || viewSize === VIEW_SIZE.medium;
  return (
    <div className={styles.sharedProduct}>
      <div className={styles.circle}>
        {percentOff > 0 && (
          <div className={styles.discountPercent}>{percentOff}% OFF</div>
        )}
        <img className={styles.image} alt={`${productName}`} src={imageUrl} />
        {brandName && <div className={styles.brand}>{brandName}</div>}
        <div className={styles.name}>
          {_.truncate(productName, { length: mobileDevices ? 35 : 45 })}
        </div>
      </div>
    </div>
  );
};

SharedProduct.propTypes = {
  product: PropTypes.shape({
    productName: PropTypes.string,
    brandName: PropTypes.string,
    imageUrl: PropTypes.string,
    percentOff: PropTypes.number,
  }).isRequired,
  viewSize: PropTypes.string.isRequired,
};

export default SharedProduct;
